import getThemeMerger from 'util/getThemeMerger'

export default getThemeMerger((currentTheme) => ({
  overrides: {
    MuiTable: {
      root: {
        'table-layout': 'fixed',
      },
    },
    MuiTableBody: {
      root: {
        '& tr td:first-child': {
          paddingRight: currentTheme.spacing(5.25),
          // Section first column (title)
          verticalAlign: 'top',
          width: '275px',
        },
        '& tr:last-child td': {
          borderBottom: 'none',
        },
      },
    },
    MuiTableCell: {
      root: {
        padding: `${currentTheme.spacing(5)}px 0`,
      },
    },
  },
}))
